<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.id">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">
        {{ activeUserInfo.first_name }} {{ activeUserInfo.last_name }}
      </p>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          key="onlineImg"
          :src="url"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="profilePage"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t("Profile") }}</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="handleLogout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t("Logout") }}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>
<script>
export default {
  data() {
    return {
      username: this.$store.getters.currentUser,
      url: require("@/assets/images/portrait/small/avatar-s-27.png"),
       show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
    };
  },
  computed: {
    activeUserInfo() {
      if (this.$store.getters.currentUser.profile_image != null) {
        this.url = this.$store.getters.currentUser.profile_image.path
          ? this.$store.getters.currentUser.profile_image.path
          : this.$store.getters.currentUser.profile_image;
      }
      return this.$store.getters.currentUser;
    },
  },
  methods: {
    /**
     * redirect to profile page
     */
    profilePage() {
      this.$router.push({ path: "/user/profile" });
    },
    /**
     * Logout API call
     */
    handleLogout() {
      this.error="";
      // Call store function
      this.$store
        .dispatch("Logout")
        .then(() => {
          this.$router.push({ path: "/user/login" });
        })
        .catch((error) => {
          // Error response
       this.error =
          this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
            ? this.$t(error.replace(/[\s\/]/g, ""))
            : error;
        this.$toasted.show(this.error, {
          className: "top-alert",
          position: "top-center",
          type: "error",
          duration: 2000,
        });
          return false;
        });
    },
  },
};
</script>

<style scoped>
p {
  margin-top: 0 !important;
  margin-bottom: 0rem !important;
}
</style>